import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { LoadingOverlay } from "components/layout/LoadingOverlay";

export const EventsLayout = () => {
    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Outlet />
        </Suspense>
    );
};
